import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../../core/services/admin.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { FileRestrictions } from '@progress/kendo-angular-upload';

@Component({
  selector: 'app-partner-pak-training-admin',
  templateUrl: './partner-pak-training-admin.component.html',
  styleUrls: ['./partner-pak-training-admin.component.scss']
})
export class PartnerPakTrainingAdminComponent implements OnInit {
  
  description: string = "";
  userLanguage: string = "";
  enableText: boolean = false;
  id: any;
  getLanguages: any;
  trainingForm: FormGroup;
  selectedLanguage: string = "";
  partnerPakInputMethod = 'TextEditor';
  partnerPakUrlPath = null;
  partnerPakUrl = null;
  constructor(private adminService: AdminService, private formBuilder: FormBuilder, private appNotifyService: AppNotifyService,
    private languageService: LanguageTranslationService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.trainingForm = this.formBuilder.group({
      id: new FormControl(0),
      description: new FormControl(""),
      languageCode: new FormControl(""),
    })
    this.languageService.getLanguages().subscribe(response => {
      this.getLanguages = response;
    })
    this.selectedLanguage = localStorage.getItem('language');
    this.lanaguageChange("");
  }

  //#region label/variable declaration
  public partnerPak = {
    languageLbl: 'Language',
    descriptionLbl: 'Description',
    isSubmitted: false,
    isLanguageCodeEmpty: false,
    isDescriptionEmpty: false,
    isEmptyPartnerPakUrlPath:false
  }
  //#endregion
  //#region save/cancel button operations
  lanaguageChange(event) {
    const body = {
      trainingType: "partnerPakTraining",
      languageCode: event ? event.languageCode : this.selectedLanguage
    }
    this.partnerPak.isLanguageCodeEmpty = false;
    this.adminService.getTrainingPagesDescription(body).subscribe(response => {
      this.enableText = true;
      if (response.length > 0) {
        
        this.trainingForm.controls.id.setValue(response[0].trainingId);
        this.partnerPak.isDescriptionEmpty = false;
        this.transformPartnerPak(response[0]);
      } else {
        this.trainingForm.controls.description.reset();
      }
    })
  }
  transformPartnerPak(partnerPak: any) {
  
    if (partnerPak) {
      if (partnerPak.urlPath) {
        this.partnerPakUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.imageUrl + partnerPak.urlPath);
        this.partnerPakInputMethod = "FileUpload";
      } else {
        this.partnerPakInputMethod = "TextEditor";
        this.trainingForm.controls.description.setValue(partnerPak.description);
        this.partnerPakUrl = null;
      }
    }
  }
  public validatePartnerPakForm(): boolean {
    let isValid = true;
    const controls = this.trainingForm.controls;
    if (this.partnerPak.isSubmitted) {
      if (controls.languageCode.value) {
        this.partnerPak.isLanguageCodeEmpty = false;
      } else {
        this.partnerPak.isLanguageCodeEmpty = true;
        isValid = false;
      }
     
      if (this.partnerPakInputMethod === "FileUpload") {
        if (this.partnerPakUrlPath) {
          this.partnerPak.isEmptyPartnerPakUrlPath = false;
        } else {
          this.partnerPak.isEmptyPartnerPakUrlPath = true;
          isValid = false;
        }
      } else {
        if (controls.description.value) {
          this.partnerPak.isDescriptionEmpty = false;
        } else {
          this.partnerPak.isDescriptionEmpty = true;
          isValid = false;
        }
      }
    }
    return isValid;
  }

  resetForm() {
    this.trainingForm.reset();
    this.enableText = false;
    this.partnerPak.isSubmitted = false;
    this.partnerPak.isLanguageCodeEmpty = false;
    this.partnerPak.isDescriptionEmpty = false;
    this.selectedLanguage = "";
  }
  savePartnerPakTrainingDescription() {
    this.partnerPak.isSubmitted = true;
    if (!this.validatePartnerPakForm()) {
      return;
    }
    const controls = this.trainingForm.controls;
      const body = {
        description: controls.description.value,
        trainingId: controls.id.value,
        trainingType: "partnerPakTraining",
        urlPath: this.partnerPakUrlPath,
        languageCode: controls.languageCode.value ? controls.languageCode.value.languageCode : this.selectedLanguage,
      }
     
      this.adminService.saveTrainingPagesDescription(body).subscribe(response => {
        //this.resetForm();
        this.selectedLanguage = body.languageCode;
        this.lanaguageChange("");
        this.appNotifyService.notify(NotifyType.SUCCESS, 'Saved successfully!');
      })
  }
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".pdf"],
  };
  partnerPakSelected(event) {
    console.log(event);
  }
  partnerPakUploadSuccess(event) {
    console.log(event);
    this.partnerPakUrlPath = event.response.body.paths[0];
    if (this.partnerPakUrlPath) {
      const url = environment.imageUrl + `/api/${this.partnerPakUrlPath}`;
      this.partnerPakUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url.replace("\\", "/"));
      this.partnerPakInputMethod = "FileUpload";
    } else {
      this.partnerPakInputMethod = "TextEditor";
    }

  }
  //#endregion
}
